import type { CSSProperties } from "react";

import { A4_METRICS } from "@/api/document/paginate";
import { TERM_FONT_STACKS } from "@/api/document/render";
import type { TermMargins, TermTypography } from "@/api/document/render";

export const DocumentPageStyle = {
	editorMargins(margins: TermMargins | undefined) {
		if (margins === undefined) {
			return;
		}

		return {
			"--e-pad-top": `${margins.top}px`,
			"--e-pad-right": `${margins.right}px`,
			"--e-pad-left": `${margins.left}px`,
		} as CSSProperties;
	},

	typography(typography: TermTypography | undefined) {
		if (typography === undefined) {
			return;
		}

		return {
			"--t-font-size": `${typography.fontSize}px`,
			"--t-leading": `${typography.lineHeight}`,
			"--t-font": TERM_FONT_STACKS[typography.fontFamily],
		} as CSSProperties;
	},

	preview(margins: TermMargins, typography: TermTypography) {
		return {
			"--t-pad-top": `${margins.top}px`,
			"--t-pad-right": `${margins.right}px`,
			"--t-pad-bottom": `${margins.bottom}px`,
			"--t-pad-left": `${margins.left}px`,
			"--t-flow-width": `${A4_METRICS.pageWidth - margins.left - margins.right}px`,
			"--t-font-size": `${typography.fontSize}px`,
			"--t-leading": `${typography.lineHeight}`,
			"--t-font": TERM_FONT_STACKS[typography.fontFamily],
		} as CSSProperties;
	},
};
